module.exports = __webpack_public_path__ + "img/bg_signature_img.48a6252c.png";